import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useT } from "@/contexts/LanguageContext";

const BG = "https://customer-assets.emergentagent.com/job_shipment-flow-37/artifacts/ngvmb0ib_Screenshot%202025-02-01%20143126.png";

export default function CTABanner() {
  const { t } = useT();
  return (
    <section data-testid="cta-banner" className="relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${BG})` }} />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/40" />
      <div className="relative z-10 container-mdgx py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-8">
          <div className="text-overline mb-4">{t("cta.overline")}</div>
          <h2 className="section-headline text-white">
            {t("cta.headline1")}<br />
            {t("cta.headline2")}<br />
            <span className="text-[#D9633F]">{t("cta.headline3")}</span>
          </h2>
          <p className="text-white/75 mt-6 max-w-xl leading-relaxed">{t("cta.sub")}</p>
        </div>
        <div className="md:col-span-4 flex flex-col gap-3 md:items-end">
          <Link to="/quote" data-testid="cta-banner-quote" className="btn-sharp btn-primary w-full md:w-auto">
            {t("cta.request")} <ArrowUpRight size={16} />
          </Link>
          <Link to="/contact" data-testid="cta-banner-contact" className="btn-sharp btn-ghost w-full md:w-auto">
            {t("cta.talk")}
          </Link>
          <a href="tel:+19053637673" className="font-mono text-sm text-white/70 hover:text-[#D9633F] mt-2 tracking-wider">+1 (905) 363-7673</a>
        </div>
      </div>
    </section>
  );
}
